import React from 'react';
import { Modal } from 'react-responsive-modal';

// react-responsive-modal renders a plain white box by default. This wraps it
// with the app's dark glass surface (see camera.css .camera-modal*) so
// modals stop clashing with the dark page behind them — the same fix the
// app applied to its own bottom sheets.
export default function DarkModal({ children, ...props }) {
    return (
        <Modal
            {...props}
            classNames={{
                overlay: 'camera-modal-overlay',
                modal: 'camera-modal',
                closeButton: 'camera-modal-close',
            }}
        >
            {children}
        </Modal>
    );
}
